const subscriptionSources = {
    SPID: 'SPID',
    SAPI: 'SAPI',
};

const changePaymentFlowSources = {
    SAPI: 'zuora',
};

export const asArray = Object.keys(subscriptionSources);

export const getChangePaymentFlowSource = source => changePaymentFlowSources[source];

export default subscriptionSources;
